import { type ReactNode } from 'react';
import { HelpButton } from '@/components/ui';
import type { HelpTopic } from './helpTopics';

/**
 * The floating help affordance for a page: the round "?" in the lower-right. Kept clean — icon
 * only, with a "Need help?" hover/focus tooltip so it stays labelled without cluttering the corner.
 * The "?" opens the help popover.
 */
export function FloatingHelp({ topic, footer }: { topic: HelpTopic; footer?: ReactNode }) {
  return <HelpButton floating floatingLabel="Need help?" {...topic} footer={footer} />;
}
